import { Box } from '@mui/material';
import { ChangeEvent, FC, useState } from 'react';
import {
  StyledDialog,
  SubtitleSecondary,
  ReasonTextArea,
  ButtonContainer,
  RejectButton,
  CancelButton,
  CloseIcon,
  ApproveButton,
} from 'src/components/DialogBox/GRNPaymentDialog/ActionPaymentDialog.styles';
import ConfirmHeader from 'src/components/Headers/ConfirmationHeader';

interface ApprovePaymentDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  subtitle?: string;
  subtitleSecondary?: string;
  placeholder?: string;
  confirmText?: string;
  isReasonEmpty?: boolean;
}

const ApprovePaymentDialog: FC<ApprovePaymentDialogProps> = ({
  open,
  onClose,
  onConfirm,
  title = 'Approve payment',
  subtitle = 'Are you sure you want to approve this Payment?',
  subtitleSecondary = 'Review and confirm the approval of this payment.',
  confirmText = 'Approve',
  isReasonEmpty = false,
}) => {
  return (
    <StyledDialog
      open={open}
      onClose={onClose}
      height={subtitleSecondary ? '300px' : '280px'}
    >
      <ConfirmHeader
        iconColor="var(--success)"
        title={title}
        subtitle={subtitle}
        mb={subtitleSecondary ? 1 : 2}
      />
      <CloseIcon component="i" className="bx bx-x-circle" onClick={onClose} />
      {subtitleSecondary && (
        <Box ml={4} display="flex" alignItems="center">
          <SubtitleSecondary>{subtitleSecondary}</SubtitleSecondary>
        </Box>
      )}
      <ButtonContainer>
        <ApproveButton onClick={onConfirm} disabled={isReasonEmpty}>
          {confirmText}
        </ApproveButton>
        <CancelButton onClick={onClose}>Cancel</CancelButton>
      </ButtonContainer>
    </StyledDialog>
  );
};

export default ApprovePaymentDialog;
